import { ApplicationConfig } from '@angular/core';
import { provideCore } from '@retail-portal-santander-frontend/shell-feature';
import { environment } from '../environments/environment';
import { VERSION } from '../environments/version';

export const appConfig: ApplicationConfig = {
  providers: [provideCore({ ...environment, version: VERSION })],
};
